import { Divider, Modal } from "antd";
import { DocumentView } from "components";
import { useEffect, useState } from "react";

type SpecInfoType = {
  text: string;
  s3_path: string;
};

type AiInsightsType = {
  field_measurement_required?: SpecInfoType;
  mockups_required?: SpecInfoType;
  mockups_proof?: SpecInfoType;
  recessed_condition?: SpecInfoType;
  recessed_proof?: SpecInfoType;
};

function PdfViewerSpecPopup({
  title,
  ai_insights,
  specSection,
  materialListFilter,
  onClose
}: {
  title: string;
  ai_insights: AiInsightsType;
  specSection: { number: string; name: string };
  materialListFilter: any;
  onClose: () => void;
}) {
  const [pdfSpecsInfo, setPdfSpecsInfo] = useState<SpecInfoType | null>(null);

  useEffect(() => {
    if (ai_insights) {
      const entities = Object.entries(ai_insights);
      if (entities.length > 0) {
        const object = entities[0][1] as SpecInfoType;
        if (object) {
          setPdfSpecsInfo(object);
        }
      }

      if (materialListFilter?.key) {
        const object =
          ai_insights[materialListFilter.key as keyof AiInsightsType];
        if (object) {
          setPdfSpecsInfo(object);
        }
      }
    } else {
      setPdfSpecsInfo(null);
    }
  }, [ai_insights, materialListFilter]);

  return (
    <Modal
      title={
        <div className="flex space-x-2 items-center">
          <div className="font-bold text-base text-ciq-gray-950-a90">
            Spec Section
          </div>
          <Divider orientation="vertical" />
          <div className="text-sm mt-1 font-medium text-black text-opacity-60 truncate max-w-2xl">
            {specSection.number} - {specSection.name}
            <span className="list-disc px-2">&bull;</span>
            {title}
          </div>
        </div>
      }
      open={!!ai_insights}
      styles={{ body: { padding: 0 } }}
      footer={null}
      onCancel={onClose}
      destroyOnHidden
      width={900}
    >
      <div className="h-[540px] w-full">
        {pdfSpecsInfo && (
          <DocumentView
            searchTexts={[pdfSpecsInfo.text]}
            file={
              {
                blob_key: pdfSpecsInfo.s3_path,
                file_name: `${specSection.number || ""} - ${specSection.name || "spec section"}.pdf`,
                file_type: "application/pdf"
              } as any
            }
            pdfStyle={{ height: "500px" }}
            auditFeatureType="MATERIALS"
          />
        )}
      </div>
    </Modal>
  );
}

export default PdfViewerSpecPopup;
